import React from 'react';
import {Link} from "react-router-dom";

function LogoItem(props) {
    
    return (
        <div className="brand-logo-item">
            {/* <Link to={`${localhost:3000 + props.URL}`}> */}
                <img src={process.env.REACT_APP_BASE_URL + props.logoSrc} style={{maxHeight:"100px"}} alt="Businex-Logo"/>
            {/* </Link> */}
        </div>
    );
}

export default LogoItem;